import React, { memo, useMemo } from 'react'
import { Card, Spin } from 'antd'
import ReactEcharts from 'echarts-for-react'
import moment from 'moment'

const SuperadminCostTrend = memo(({ data, loading }) => {
  const chartOption = useMemo(() => {
    if (!data?.timelineData || data.timelineData.length === 0) return null

    // Sort by date if not already sorted
    const sortedData = [...data.timelineData].sort((a, b) => new Date(a.date) - new Date(b.date))
    
    const xAxisData = sortedData.map(item => moment(item.date).format('MMM DD'))
    const costData = sortedData.map(item => item.cost.toFixed(2))
    const creditData = sortedData.map(item => item.credits.toFixed(2))

    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'cross' }
      },
      legend: {
        data: ['Cost ($)', 'Credits'],
        bottom: 0
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: xAxisData,
          axisPointer: { type: 'shadow' }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Cost ($)',
          axisLabel: { formatter: '${value}' }
        },
        {
          type: 'value',
          name: 'Credits',
          axisLabel: { formatter: '{value}' }
        }
      ],
      series: [
        {
          name: 'Cost ($)',
          type: 'bar',
          itemStyle: { color: '#44959A' },
          data: costData
        },
        {
          name: 'Credits',
          type: 'line',
          yAxisIndex: 1,
          itemStyle: { color: '#5B6EE2' },
          data: creditData
        }
      ]
    }
  }, [data])

  if (!data && !loading) return null

  return (
    <Card className="superadmin-cost-trend-card" style={{ height: '100%', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
      <Spin spinning={loading}>
        <div style={{ padding: '4px 0' }}>
          <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#111827', margin: '0 0 16px 0' }}>Usage Trends Over Time</h3>
          {chartOption ? (
            <ReactEcharts option={chartOption} style={{ height: '300px' }} />
          ) : (
            <div style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: '13px' }}>
              No trend data available for the selected period
            </div>
          )}
        </div>
      </Spin>
    </Card>
  )
})

SuperadminCostTrend.displayName = 'SuperadminCostTrend'
export default SuperadminCostTrend
